<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDeleteBtn">删除</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button>
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_id'"
                v-model="data.head['id']"
                code="id"
                name="ID"
                :default-value="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_storeCode'"
                v-model="data.head['storeCode']"
                url="base/user/user/store/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="storeCode"
                name="门店编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_storeName'"
                v-model="data.head['storeName']"
                code="storeName"
                name="门店名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-text
                :ref="'input_prescriptionSource'"
                v-model="data.head['prescriptionSource']"
                code="prescriptionSource"
                name="方剂出处"
                default-value=""
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_prescriptionTypeSign'"
                v-model="data.head['prescriptionTypeSign']"
                code="prescriptionTypeSign"
                name="方剂类型"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.prescriptionTypeSign)"
                :disabled="true"
                :require="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_decoctSign'"
                v-model="data.head['decoctSign']"
                code="decoctSign"
                name="加工方式"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.decoctSign)"
                :require="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <el-form-item label="主诉" class="treatment-form-item">
                <key-word
                  v-model="data.head['symContent']"
                  code="sym"
                  @change="onFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="既往史" class="treatment-form-item">
                <key-word
                  v-model="data.head['hisContent']"
                  code="his"
                  @change="onFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="家族史" class="treatment-form-item">
                <key-word
                  v-model="data.head['familyContent']"
                  code="family"
                  @change="onFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体质" class="treatment-form-item">
                <key-word
                  v-model="data.head['phyContent']"
                  code="phy"
                  :label-width="180"
                  @change="onFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="四诊" class="treatment-form-item">
                <key-word
                  v-model="data.head['fdmContent']"
                  code="fdm"
                  @change="onFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="诊断" class="treatment-form-item">
                <key-word
                  id="key3"
                  v-model="data.head['diagContent']"
                  code="diag"
                  @change="onFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中医病" class="treatment-form-item">
                <key-word
                  v-model="data.head['chDiagContent']"
                  code="chDiag"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中医症" class="treatment-form-item">
                <key-word
                  v-model="data.head['cChYndromeContent']"
                  code="chYndrome"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="治法" class="treatment-form-item">
                <key-word
                  v-model="data.head['chTherapyContent']"
                  code="chTherapy"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_dayNum'"
                v-model="data.head['dayNum']"
                code="dayNum"
                name="用药天数"
                :default-value="0"
                :precision="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_dayDoseNum'"
                v-model="data.head['dayDoseNum']"
                code="dayDoseNum"
                name="每日剂量"
                :default-value="0"
                :precision="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_dayFreq'"
                v-model="data.head['dayFreq']"
                code="dayFreq"
                name="每日次数"
                :default-value="0"
                :precision="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_doseNum'"
                v-model="data.head['doseNum']"
                code="doseNum"
                name="剂数"
                :default-value="0"
                :precision="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 表身 -->
        <el-tabs
          v-if="viewMode == 'info'"
          ref="ik-info-body"
          v-model="activeTab"
          class="std-prescription-tabs-info"
          type="card"
        >
          <el-tab-pane
            :key="bodyMap[0].key"
            :name="bodyMap[0].key"
            :label="bodyMap[0].name"
            style="height:100%;"
          >
            <el-table
              ref="tablesub"
              v-loading="loading"
              v-horizontal-scroll="'always'"
              :data="data.body[bodyMap[0].key]"
              element-loading-text="加载中..."
              :stripe="true"
              :border="true"
              :fit="true"
              class="ik-list-table"
              height="100%"
              :header-row-class-name="'ik-list-table-header-row'"
              :header-cell-class-name="'ik-list-table-header-cell'"
              :row-class-name="'ik-list-table-body-row'"
              :cell-class-name="'ik-list-table-body-cell'"
              :highlight-current-row="true"
            >
              <el-table-column
                v-if="mode !== 'details'"
                prop="pluss"
                label="操作"
                width="180"
              >
                <template v-slot:header>
                  <div class="button-action">
                    <span style="padding:0px 12px;">操作</span><el-button circle :style="{width:'26px',height:'26px',color:'#409EFF',padding:'3px 0','margin-top':'3px'}" title="添加首行" @click="addRow(activeTab, -1)">+</el-button>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="button-action">
                    <el-button circle :style="{width:'28px',height:'28px',color:'#409EFF',padding:'3px 0','margin-top':'3px'}" @click.stop="addRow(bodyMap[0].key, scope.$index)">+</el-button>
                    <el-button circle :style="{width:'28px',height:'28px',color:'#409EFF',padding:'3px 0','margin-top':'3px'}" @click.stop="delRow(bodyMap[0].key, scope.$index)">-</el-button>
                  </div>
                </template>
              </el-table-column>
              <ik-column-id
                code="id"
                name="ID"
                :edit="mode !== 'details'"
                @onFieldChange="onBodyFieldChange"
              />
              <ik-column-text
                code="materielCode"
                name="药品编码"
                :edit="false"
                @onFieldChange="onBodyFieldChange"
              />
              <ik-column-data-popup
                code="materielName"
                name="药品名称"
                url="clinic/clinicdic/clinicmedicinedic/clinicmateriel/find/findPagination"
                :filed-list="[
                  { code: 'materielCode', name: '编码' },
                  { code: 'materielName', name: '名称' },
                ]"
                search-key="materielName"
                :searcher="{storeCode: storeCode, effectiveSign: '1', materielTypeSign: data.head['positionClassifySign']}"
                :edit="mode !== 'details'"
                @onFieldChange="onBodyFieldChange"
                @onPopupClick="bodyPopupClick"
              />
              <ik-column-text
                code="decoctionCode"
                name="煎法编码"
                :edit="mode !== 'details'"
              />
              <ik-column-data-popup
                code="decoctionName"
                name="煎法名称"
                url="clinic/clinicdic/clinicmedicinedic/clinicmeddic/find/findPagination"
                :filed-list="[
                  { code: 'medDictionaryCode', name: '编码' },
                  { code: 'medDictionaryName', name: '名称' },
                ]"
                search-key="medDictionaryName"
                :searcher="{storeCode: data.head['storeCode'], medDirectoryCode: 'JZ', effectiveSign: '1'}"
                :edit="mode !== 'details'"
                @onPopupClick="bodyPopupClick"
              />
              <ik-column-text
                code="medUomCode"
                name="药品单位编码"
                :edit="mode !== 'details'"
              />
              <ik-column-text
                code="medUomName"
                name="药品单位名称"
                :edit="mode !== 'details'"
              />
              <ik-column-number
                code="singleNum"
                name="单剂数量"
                :edit="mode !== 'details'"
              />
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_decoctSign'"
                      v-model="searcher['decoctSign']"
                      code="decoctSign"
                      name="代加工"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.decoctSign)"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-id
            code="id"
            name="ID"
            :edit="false"
          />
          <ik-column-text
            code="code"
            name="编码"
            :edit="false"
          />
          <ik-column-text
            code="name"
            name="名称"
            :edit="false"
          />
          <ik-column-text
            code="storeCode"
            name="门店编码"
            :edit="false"
          />
          <ik-column-text
            code="storeName"
            name="门店名称"
            :edit="false"
          />
          <ik-column-text
            code="prescriptionSource"
            name="方剂出处"
            :edit="false"
          />
          <ik-column-select
            code="prescriptionTypeSign"
            name="方剂类型"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.prescriptionTypeSign)"
            :edit="false"
          />
          <ik-column-select
            code="decoctSign"
            name="加工类型"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.decoctSign)"
            :edit="false"
          />
          <ik-column-text
            code="symContent"
            name="主诉"
            :edit="false"
          />
          <ik-column-text
            code="code"
            name="既往史"
            :edit="false"
          />
          <ik-column-text
            code="familyContent"
            name="家族史"
            :edit="false"
          />
          <ik-column-text
            code="phyContent"
            name="体质"
            :edit="false"
          />
          <ik-column-text
            code="fdmContent"
            name="四诊"
            :edit="false"
          />
          <ik-column-text
            code="diagContent"
            name="西医病"
            :edit="false"
          />
          <ik-column-text
            code="chDiagContent"
            name="中医病"
            :edit="false"
          />
          <ik-column-text
            code="chYndromeContent"
            name="中医证"
            :edit="false"
          />
          <ik-column-text
            code="chTherapyContent"
            name="治法"
            :edit="false"
          />
          <ik-column-text
            code="dayNum"
            name="用药天数"
            :edit="false"
          />
          <ik-column-text
            code="dayDoseNum"
            name="每日剂数"
            :edit="false"
          />
          <ik-column-text
            code="dayFreq"
            name="每日次数"
            :edit="false"
          />
          <ik-column-text
            code="doseNum"
            name="剂数"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
// 表单组件
import IkFormId from '@/components/ik/form/input/IkFormId'
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormNumber from '@/components/ik/form/input/IkFormNumber'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkColumnId from '@/components/ik/table/ikColumn/IkColumnId'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnNumber from '@/components/ik/table/ikColumn/IkColumnNumber'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkColumnDataPopup from '@/components/ik/table/ikColumn/IkColumnDataPopup'
import IkPagination from '@/components/ik/pagination/IkPagination'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import KeyWord from './KeyWord.vue'
import store from '@/store'
import { getById, findPage, save, update, remove } from '@/api/ik/data/dataApi'
export default {
  components: {
    // 表单组件
    IkFormId,
    IkFormText,
    IkFormNumber,
    IkFormSelect,
    IkColumnId,
    IkColumnText,
    IkColumnNumber,
    IkColumnSelect,
    KeyWord,
    IkColumnDataPopup,
    IkPagination,
    IkFormDataPopup
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeCode: store.getters['user/getStoreCode'],
      storeId: store.getters['user/getStoreId'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'clinic/treatment/stdprescription/stdprescription',
      // Web路径
      webPath: 'clinic/treatment/std_prescription/std_prescription',
      // 标识字段JSON
      jsonStr: {
        prescriptionTypeSign: '[{"key": "1", "value": "经方"}, {"key": "2", "value": "验方"}, {"key": "3", "value": "名方"}, {"key": "2", "value": "门店方"}]',
        decoctSign: '[{"key": "00", "value": "不加工"},{"key": "01", "value": "代煎"},{"key": "11", "value": "制粒"},{"key": "21", "value": "细粉打粉"},{"key": "22", "value": "粗粉打粉"},{"key": "31", "value": "水丸制丸"},{"key": "32", "value": "蜜丸制丸"},{"key": "33", "value": "大蜜丸制丸"},{"key": "34", "value": "浓缩丸制丸"},{"key": "35", "value": "水蜜丸制丸"},{"key": "41", "value": "制瓶装膏"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: { },
        body: { 'stdPrescriptionItem': [] }
      },
      // 子表清单
      bodyMap: [{ key: 'stdPrescriptionItem', name: '标准处方项' }],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: 'stdPrescriptionItem',
      verify: {
        head: {},
        body: {}
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/manager/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/manager/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/manager/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/manager/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 详情点击事件
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/manager/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue) {
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "storeCode") {
        this.searcher["storeCode"] = row.code
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "storeCode") {
        this.data.head["storeId"] = row.id
        this.data.head["storeCode"] = row.code
        this.data.head["storeName"] = row.name
      }
    },
    // 开窗点击事件
    bodyPopupClick(line, code, row) {
      // 如果是药品字典点击
      if (code === "materielName") {
        this.$set(this.data.body["stdPrescriptionItem"][line], 'materielId', row.materielId)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'materielCode', row.materielCode)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'materielName', row.materielName)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'iotCode', row.materielIotCode)
      } else if (code === "iotCode") {
        this.$set(this.data.body["stdPrescriptionItem"][line], 'materielId', row.materielId)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'materielCode', row.materielCode)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'materielName', row.materielName)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'iotCode', row.materielIotCode)
      } else if (code === "decoctionName") {
        this.$set(this.data.body["stdPrescriptionItem"][line], 'decoctionId', row.medDictionaryId)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'decoctionCode', row.medDictionaryCode)
        this.$set(this.data.body["stdPrescriptionItem"][line], 'decoctionName', row.medDictionaryName)
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      $this.searcher.storeCode = this.storeCode
      // 获取树组件数据
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    }
  }
}
</script>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
.std-prescription-tabs-info{height:calc(100% - 110px);}
.std-prescription-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
</style>
